export default "__VITE_ASSET__DipBQvIs__"